module.exports = __webpack_public_path__ + "954091b6444514717cf412cc8ed6816d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash-red-hover.png
// module id = 226
// module chunks = 0